// login
export const SUBMIT_LOGIN = "SUBMIT_LOGIN";
export const LOGIN_ERROR = "LOGIN_ERROR";

// signup
export const SUBMIT_SIGNUP = "SUBMIT_SIGNUP";

// logout
export const DELETE_LOGIN = "DELETE_LOGIN";
